import {
  AfterViewChecked,
  AfterViewInit,
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  QueryList,
  ViewChildren, ChangeDetectorRef,
} from '@angular/core';
import {DataService} from '../../../../Services/data.service';
import { DateFilterService } from '../../../../Services/dateFilter.service';
import { Title } from '@angular/platform-browser';
import { FilterPipe } from 'ngx-filter-pipe';
import { StorageService } from '../../../../Services/storage.service';
import { DataExportService } from '../../../../Services/dataExport.service';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import {DatePipe, DecimalPipe} from '@angular/common';
import { AppConfigService } from '../../../../Services/app-config.service';
import { ResponseModel } from '../../../../DataModels/response-model';
import { SendEmailInfoModel } from '../../../../DataModels/send-email-info-model';
import { EmailModel } from '../../../../DataModels/email-model';
import { ActivityFeedModel } from '../../../../DataModels/activity-feed-model';
import { ConfirmDialogService } from '../../../../Services/confirm-dialog.service';
import { BsToastService } from '../../../../Services/bs-toast-service';
import { take } from 'rxjs/operators';
import {HttpResponse} from '@angular/common/http';
import {Modal} from 'bootstrap';
import {RoutingTrackerService} from '../../../../Services/routing-tracker.service';
import {ReportPrintService} from '../../../../Services/report-print.service';


@Component({
  selector: 'app-statements',
  templateUrl: './statements.component.html',
  styleUrls: ['./statements.component.css'],
  standalone: false
})
export class StatementsComponent implements OnInit, AfterViewInit, AfterViewChecked {
  private rptName: string;
  @ViewChild('EmailContent', { static: false }) EmailContent: ElementRef;

  @ViewChildren('statement') statementsList: QueryList<any>;

  // email statements
  @ViewChildren('Email') EmailFromDoc: QueryList<ElementRef>;
  @ViewChildren('EntityId') EntityFromDoc: QueryList<ElementRef>;
  @ViewChildren('StatementForm') FormDocument: QueryList<ElementRef>;

  hideDetails;
  public vm: any = {
    dateError: null,
    showFilters: false,
    report: [],
    buttonsDisabled: false,
    entityType: [],
    company: [],
    location: [],
    entity: [],
    currency: [],
    request: {
      toDate: null,
      fromDate: null,
      includePaid: null,
      entity_id: null,
      entity_type_id: null,
      company_id: null,
      currency_id: null,
    },
    entityFilter: {
      name: null,
    },
    email: {
      toemail: null,
      fromemail: this.appConfig.SysEmailAddress,
      PdfHtml: null,
      Subject: null,
    },
    totalOwing: null,
    totalCurrent: null,
    total1to30: null,
    total31to60: null,
    total61to90: null,
    total91plus: null,
    payment: {},
    entityInput: '',
    filtered: false,
    subLedger: null,
    showEmail: true,
    entity_email: null,
    entityName: [],
    startEntity: 0,
    exportToExcel: true,
    payTotals: null,
    fromDateSelect: [],
    toDateSelect: [],
    monthCount: 0,
  };
  company_id;
  days_late;

  public urlParams: any = [];

  emailInfo = new SendEmailInfoModel();
  objEmail = new EmailModel();
  af = new ActivityFeedModel();

  // Standard header buttons: use unified print/email pipeline (no direct window.print)
  buttonConfig: any = {
    reportFormat: false,
    print: false,
    printReport: true,
    email: true,
    update: true,
    exportExcel: true,
  };

  emailToSendArray: EmailModel[] = [];
  entityIdArray = [];
  emailAddressesFromDocArray = [];
  reportFormatCheckBoxValue = true;
  reportDataToSendInEmail: EmailModel = new EmailModel();

  routedFrom = '';
  noDataFound = false;

  constructor(
      public tableDataService: DataService,
    public dateFilter: DateFilterService,
    private titleService: Title,
    public localStorage: StorageService,
    public excelExporter: DataExportService,
    private route: ActivatedRoute,
    private router: Router,
    public appConfig: AppConfigService,
    public confirmDialogService: ConfirmDialogService,
    public notificationService: BsToastService,
    public changeDetector: ChangeDetectorRef,
      public prevUrl: RoutingTrackerService,
      private reportPrint: ReportPrintService
  ) {
    const prevUrl2 = this.prevUrl.getPreviousUrl();

    if (prevUrl2 !== null && prevUrl2 !== undefined) {
      this.routedFrom = prevUrl2;
    } else {
      this.routedFrom = '';
    }
  }

  ngOnInit() {

    this.urlParams = this.route.snapshot.queryParams;

    const hasUrlDates = !!(this.urlParams.fromDate || this.urlParams.toDate);
    this.route.queryParamMap.subscribe((params: ParamMap) => {
      this.vm.Preferences = JSON.parse(this.localStorage.StorageGet('Preferences'));
      this.vm.permissions = JSON.parse(this.localStorage.StorageGet('Permissions'));

      if (!this.vm.permissions.ReceivableStatements && !this.vm.permissions.Admin) {
        document.location.href = '/';
      }

      this.vm.print = [];
      this.FilterOptionsInit().then(() => {
        if (hasUrlDates && this.vm.request.toDate) {
          this.update().then();
        }
      });

      this.rptName = $localize`:Statement Report @@statementReport:Statement Report`;
    });
    this.vm.report_format = true;
  }

  ngAfterViewInit() {
    this.titleService.setTitle(this.rptName);
    this.statementsList.changes.subscribe((r) => {
    });
  }

  ngAfterViewChecked() {
    // No-op: unified email/print HTML is built on demand via buildPrintHtml()
  }

  async FilterOptionsInit() {
    this.tableDataService
        .getData('company?state=active&pageNumber=0&pageSize=999999')
      .subscribe((result: ResponseModel) => {
        this.vm.company = result.Data;
      });
    this.tableDataService
        .getData('currency?state=active&pageNumber=0&pageSize=999999')
      .subscribe((result: ResponseModel) => {
        this.vm.currency = result.Data;
      });
    this.vm.entity = await this.getFilterValues('entity', '?state=active');
    for (const [x, value] of Object.entries(this.vm.entity)) {
      this.vm.entityName.push({ name: this.vm.entity[x].name });
    }
    // console.log('entity:' + JSON.stringify(this.vm.entity));
    if (this.urlParams.entity_id != null || this.urlParams.entity_id != undefined) {
      for (const [y, value] of Object.entries(this.vm.entity)) {
        if (this.vm.entity[y]) {
          if (this.vm.entity[y].id == this.urlParams.entity_id) {
            this.vm.entityInput = this.vm.entity[y].name;
            this.vm.request.entity_id = this.vm.entity[y].id;
            this.vm.request.entity_email = this.vm.entity[y].email;
            break;
          }
        }
      }
    }

    if (this.urlParams.fromDate) {
      this.vm.request.fromDate = this.urlParams.fromDate;
    }

    if (this.urlParams.toDate) {
      this.vm.request.toDate = this.urlParams.toDate;
    }

    if (!this.vm.request.toDate && !this.vm.request.fromDate) {
      const range = this.dateFilter.GetDefaultDateRange('currentMonth', [], []);
      this.vm.request.toDate = range.toDate;
      this.vm.request.fromDate = range.fromDate;
    }
    const ret = this.dateFilter.DateFilterInit(this.vm.request.toDate, this.vm.request.fromDate);
    this.vm.fromDateSelect = ret.fromDateSelect;
    this.vm.toDateSelect = ret.toDateSelect;
    this.vm.monthCount = ret.monthCount;
  }

  async getFilterValues(tablename, param) {
    let values: any;
    values = null;
    await this.tableDataService
        .getData(tablename + param + '&pageNumber=0&pageSize=99999')
      .toPromise()
      .then((result: ResponseModel) => {
        const data: any = result.Data;
        values = data;
      });
    // this.localStorage.StorageSet(tablename, JSON.stringify(values));
    return values;
  }

  async getEmail() {
    // because ng .toArray makes elementref array - I have to build my own regular array - index will match main doc since in same doc
    this.emailAddressesFromDocArray = [];
    this.EmailFromDoc.changes.pipe(take(1)).subscribe((r) => {
      this.EmailFromDoc.forEach((el, index) => {
        // console.log(`index ${index} :` + el.nativeElement.innerText);
        this.emailAddressesFromDocArray.push(el.nativeElement.innerText);
      });
    });
    // console.log('recid array: ' + JSON.stringify(this.recIdArray));
    return this.emailAddressesFromDocArray;
  }

  async getEntityId() {
    // because ng .toArray makes elementref array - I have to build my own regular array - index will match main doc since in same doc
    this.entityIdArray = [];
    this.EntityFromDoc.changes.pipe(take(1)).subscribe((r) => {
      this.EntityFromDoc.forEach((el, index) => {
        // console.log(`index ${index} :` + el.nativeElement.innerText);
        this.entityIdArray.push(el.nativeElement.innerText);
      });
    });
    // console.log('ent id array: ' + JSON.stringify(this.entityIdArray));
    return this.entityIdArray;
  }

  sendStatements() {
    this.confirmDialogService.confirmThis(
      ['Send Statements', 'This will email statements to all customers with valid emails shown in this report.', 'This action cannot be undone.'],
      () => {
        const toDate = this.dateFilter.GetDateFormat(this.vm.request.toDate, 'yyyy-MM-dd');
        const items: any[] = [];

        // Read directly from DOM QueryLists at call time — avoids stale pre-populated arrays
        const entityIds: string[] = [];
        this.EntityFromDoc.forEach(el => entityIds.push(el.nativeElement.innerText.trim()));

        this.FormDocument.forEach((element, index) => {
          items.push({
            entity_id: entityIds[index],
            html_to_pdf: element.nativeElement.outerHTML,
            statement_date: toDate
          });
        });

        if (items.length === 0) {
          this.notificationService.showWarningToast('No customers found.');
          return;
        }

        const invalidEmails: any[] = this.vm.invalidEmails ?? [];
        if (invalidEmails.length > 0) {
          this.notificationService.showWarningToast(
            `${invalidEmails.length} customer(s) have no valid email address and will be skipped: ` +
            invalidEmails.map((e: any) => e.entity_name).join(', ')
          );
        }

        this.tableDataService.post('emailstatements', items).subscribe({
          next: (results: any[]) => {
            const sent = results.filter((r: any) => r.success).length;
            const skipped = results.filter((r: any) => !r.success).length;
            this.notificationService.showSuccessToast(`${sent} statement(s) sent, ${skipped} skipped.`);
            results.filter((r: any) => !r.success).forEach((r: any) => {
              console.warn(`Skipped ${r.entity_name}: ${r.message}`);
            });
          },
          error: () => {
            this.notificationService.showErrorToast('Error sending statements.');
          }
        });
      },
      () => {
      }
    );
  }

  setEmailData() {
    // Build the email object using the unified HTML builder and open the modal
    const emailDocObj = {} as EmailModel;
    const reportName = this.vm.report_format ? 'Statement Report' : 'Statement';

    // printing options
    emailDocObj.print_orientation = '1';
    emailDocObj.convert_attachment_to = 'pdf';
    emailDocObj.fromEmail = '';
    emailDocObj.fromName = 'AcctXErp';
    emailDocObj.header_id = '' as any;
    emailDocObj.toEmail = '';
    emailDocObj.body = 'Please see the attached ' + reportName + '.<br><br><br>'
      + 'Best regards,'
      + '<br><br>'
      + 'AcctXErp'
      + '<br><br>';
    emailDocObj.Subject = 'AcctXErp ' + reportName;

    // Ensure any checkbox state side-effects are applied (build per current selection)
    try {
      this.reportFormat(this.reportFormatCheckBoxValue);
    } catch { /* noop */
    }

    try {
      emailDocObj.pdfHtml = this.buildPrintHtml(true);
    } catch {
      emailDocObj.pdfHtml = '' as any;
    }
    emailDocObj.activity_message = reportName + ' Sent';

    // deterministic filename
    const now = new Date();
    const yyyy = String(now.getFullYear());
    const mm = String(now.getMonth() + 1).padStart(2, '0');
    const dd = String(now.getDate()).padStart(2, '0');
    emailDocObj.FileName = (this.vm.report_format ? 'Statement_Report_' : 'Statement_') + `${yyyy}${mm}${dd}.pdf`;

    this.reportDataToSendInEmail = emailDocObj;

    const element = document.getElementById('sendEmailModal') as HTMLElement;
    if (element) {
      const emailModal = new Modal(element);
      emailModal.show();
    }
  }

  printReport() {
    try {
      const html = this.buildPrintHtml();
      this.reportPrint.printInIframe(html);
    } catch (e) {
      console.error('Statements print failed', e);
      this.notificationService?.showWarningToast?.('Unable to print Statements');
    }
  }

  // Build report-format export HTML from data (no DOM dependency)
  private buildExportHtml(): string {
    const fmt = (v: number) => new DecimalPipe('en-US').transform(Math.abs(v), '1.2-2') || '0.00';
    const cell = (v: number) => v >= 0 ? fmt(v) : `(${fmt(v)})`;
    const thStyle = 'border-bottom:2px solid #ddd;text-align:right;padding:4px;';
    const sections: string[] = [];
    const report: any[] = this.vm.report || [];
    for (const r of report) {
      const rows: string[] = [];
      if (!this.hideDetails) {
        for (const i of (r.invoices || [])) {
          const dateStr = i.header_date ? new Date(i.header_date).toLocaleDateString('en-US', {
            month: 'short',
            day: 'numeric',
            year: 'numeric'
          }) : '';
          const dueStr = i.due_date ? new Date(i.due_date).toLocaleDateString('en-US', {
            month: 'short',
            day: 'numeric',
            year: 'numeric'
          }) : '';
          rows.push(`<tr>
            <td style="border-bottom:1px solid #ddd">${i.document || ''}: ${i.number || ''}</td>
            <td style="border-bottom:1px solid #ddd">${i.description || ''}</td>
            <td style="text-align:center;border-bottom:1px solid #ddd">${dateStr}</td>
            <td style="text-align:center;border-bottom:1px solid #ddd">${dueStr}</td>
            <td style="text-align:right;border-bottom:1px solid #ddd">${cell(i.amount)}</td>
            <td style="text-align:right;border-bottom:1px solid #ddd">${cell(i.applied_amount)}</td>
            <td style="text-align:right;border-bottom:1px solid #ddd">${cell(i.owing)}</td>
            <td style="text-align:right;border-bottom:1px solid #ddd">${i.days_late || ''}</td>
          </tr>`);
          for (const ad of (i.applied_documents || [])) {
            const adDate = ad.applied_date ? new Date(ad.applied_date).toLocaleDateString('en-US', {
              month: 'short',
              day: 'numeric',
              year: 'numeric'
            }) : '';
            rows.push(`<tr style="font-size:0.85em;color:#666">
              <td></td>
              <td style="padding-left:1.5em;font-style:italic;border-bottom:1px solid #eee">${ad.document || ''}: ${ad.number || ''} — ${ad.description || ''}</td>
              <td style="text-align:center;border-bottom:1px solid #eee">${adDate}</td>
              <td colspan="5" style="border-bottom:1px solid #eee"></td>
            </tr>`);
          }
        }
      }
      rows.push(`<tr style="text-align:right">
        <td colspan="5" style="border-bottom:1px solid #ddd;text-align:${this.hideDetails ? 'left' : 'right'}">${!this.hideDetails ? 'Total ' : ''}${r.name}</td>
        <td style="text-align:right;border-bottom:1px solid #ddd">${cell(r.totalAmount)}</td>
        <td style="text-align:right;border-bottom:1px solid #ddd">${cell(r.totalApplied)}</td>
        <td style="text-align:right;border-bottom:1px solid #ddd">${cell(r.totalOwing)}</td>
        <td style="border-bottom:1px solid #ddd">&nbsp;</td>
      </tr>`);
      sections.push(`<div style="margin-bottom:24px">
        <div style="font-weight:bold;font-size:14px;margin-bottom:6px">${r.name}</div>
        <table width="100%" style="border-collapse:collapse">
          <thead><tr>
            <th style="${thStyle}text-align:left">&nbsp;</th>
            <th style="${thStyle}text-align:left">Description</th>
            <th style="${thStyle}text-align:center">${!this.hideDetails ? 'Date' : ''}</th>
            <th style="${thStyle}text-align:center">${!this.hideDetails ? 'Due' : ''}</th>
            <th style="${thStyle}">${!this.hideDetails ? 'Original' : ''}</th>
            <th style="${thStyle}">${!this.hideDetails ? 'Applied' : ''}</th>
            <th style="${thStyle}">Balance</th>
            <th style="${thStyle}">Days Past Due</th>
          </tr></thead>
          <tbody>${rows.join('')}</tbody>
        </table>
      </div>`);
    }
    return sections.join('');
  }

  private buildPrintHtml(forEmail: boolean = false): string {
    let content = '';
    if (this.vm.report_format === true) {
      content = this.buildExportHtml();
    } else {
      // Use the form content (all statement forms concatenated if present)
      try {
        const forms = document.querySelectorAll('#statement-form');
        if (forms && forms.length) {
          content = Array.from(forms).map((el: any) => el?.outerHTML || '').join('<hr />');
        } else {
          // fallback to the first form container by template reference if any
          const el = document.getElementById('statement-form');
          content = (el?.outerHTML || '').toString();
        }
      } catch {
        content = '';
      }
    }

    // If content might be hidden via d-none or inline styles, sanitize to ensure visibility in Email/PDF
    if (content) {
      try {
        content = content.replace(/class="([^"]*)"/g, (match, cls) => {
          const newCls = String(cls).split(/\s+/).filter((c: string) => c && c !== 'd-none' && c !== 'hidden').join(' ');
          return `class="${newCls}"`;
        });
        content = content.replace(/style="([^"]*)"/g, (match, style) => {
          const newStyle = String(style)
            .split(';')
            .map(s => s.trim())
            .filter(s => s && !/^display\s*:\s*none\s*$/i.test(s))
            .join('; ');
          return `style="${newStyle}"`;
        });
      } catch { /* noop */
      }
    }

    const title = this.vm.report_format ? 'Statement Report' : 'Statement';
    const toDate = this.vm?.request?.toDate || '';
    const fromDate = this.vm?.request?.fromDate || '';
    const meta: { label: string; value: string }[] = [];
    if (fromDate || toDate) {
      meta.push({label: 'Period', value: `${fromDate} to ${toDate}`});
    }
    if (this.vm.entityInput) {
      meta.push({label: 'Entity', value: this.vm.entityInput});
    }
    return this.reportPrint.buildHtml({title, contentHtml: content, meta, orientation: 'portrait', noHeader: !this.vm.report_format});
  }


  reportFormat(event: any) {
    // console.log('report format: ' + event);
    this.emailToSendArray = [];
    this.reportFormatCheckBoxValue = event;
    this.vm.report_format = event;
    const emailRegExp = new RegExp(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);

    if (this.vm.report.length > 0 && !event) {
      // console.log('subscribing');
      this.getEmail().then();
      this.getEntityId().then();
      this.FormDocument.changes.pipe(take(1)).subscribe(async (r) => {


        // console.log('email array before subscribe main doc: ' + JSON.stringify(this.emailAddressesFromDocArray));
        let noEmailAddress = false;
        let noEmailAddressCount = 0;

        this.FormDocument.forEach((element, index) => {

          const emailDocObj = {} as EmailModel;
          emailDocObj.entity_id = this.entityIdArray[index];
          emailDocObj.header_id = '';
          emailDocObj.activity_message = 'Statement emailed';
          emailDocObj.fromEmail = '';
          emailDocObj.FileName = 'Statement.pdf';
          emailDocObj.fromName = 'AcctXErp';
          emailDocObj.toEmail = this.emailAddressesFromDocArray[index];
          emailDocObj.body = 'Please see the attached Statement.' + '<br><br><br>'
            + 'Best regards,'
            + '<br><br>'
            + 'AcctXErp'
            + '<br><br>';
          emailDocObj.Subject = 'AcctXErp Statement';
          emailDocObj.pdfHtml = element.nativeElement.outerHTML;

          // if (emailDocObj.toEmail) {
          if (emailRegExp.exec(emailDocObj.toEmail)) {
            this.emailToSendArray.push(emailDocObj);
          } else {
            noEmailAddress = true;
            noEmailAddressCount += 1;
          }

          // console.log(this.emailToSendArray.push(emailDocObj));
        });
        // console.log('testArray of email and html: ' + JSON.stringify(this.emailToSendArray));

        if (noEmailAddress) {
          this.notificationService.showWarningToast(
            noEmailAddressCount + ' item(s) have no To email address and will not be sent if emailed'
          );
        }
      });
    }
  }

  async update() {
    this.vm.buttonsDisabled = true;
    this.vm.request.toDate = this.dateFilter.GetDateFormat(this.vm.request.toDate);
    const urlParamsJson = {
      subLedger: 'ar',
      toDate: this.dateFilter.GetDateFormat(this.vm.request.toDate, 'yyyy-MM-dd'),
      entity_id: this.vm.request.entity_id,
      entity_type_id: this.vm.request.entity_type_id,
      company_id: this.vm.request.company_id,
    };
    const urlParams: string = this.encodeQueryData(urlParamsJson);
    this.tableDataService.getData('aging/statements', '?' + urlParams).subscribe((result: any) => {
      this.vm.report = result.statements ?? result;
      this.vm.invalidEmails = result.invalid_emails ?? [];
      this.noDataFound = !this.vm.report || (this.vm.report as any[]).length === 0;
      this.calcReportTotals();
      this.vm.showFilters = false;
      this.vm.buttonsDisabled = false;
      this.vm.payment = {};
      if (this.vm.entityInput) {
        this.vm.filtered = true;
      } else {
        this.vm.filtered = false;
      }
      this.reportFormat(this.reportFormatCheckBoxValue);
      // this.localStorage.StorageSet('toDate', this.vm.request.toDate);
    });
    this.changeDetector.detectChanges();
  }

  exportToExcel() {
    this.vm.buttonsDisabled = true;
    this.excelExporter.exportHtmlToExcel(this.buildExportHtml(), 'Statement Report.xlsx');
    this.vm.buttonsDisabled = false;
  }

  setReportData() {
    // console.log('here');
  }

  calcReportTotals() {
    let reportBalance = 0;
    let reportAmount = 0;
    let reportApplied = 0;
    let reportCurrent = 0;
    let report1 = 0;
    let report30 = 0;
    let report60 = 0;
    let report90 = 0;
    for (const [x, value] of Object.entries(this.vm.report)) {
      let entityOwing = 0;
      let entityAmount = 0;
      let entityApplied = 0;
      let entityCurrent = 0;
      let entity1 = 0;
      let entity30 = 0;
      let entity60 = 0;
      let entity90 = 0;
      for (const [y, value2] of Object.entries(this.vm.report[x].invoices)) {
        const inv = this.vm.report[x].invoices[y];
        // Only count main invoice/credit lines (type 2=AR Invoice, 4=AP Invoice) in totals
        // Payment rows (type 3/5) are shown as detail lines and excluded from totals
        if (inv.type_id === 2 || inv.type_id === 4) {
          entityOwing += inv.owing;
          entityAmount += inv.amount;
          entityApplied += inv.applied_amount;
          if (inv.days_late <= 0) {
            entityCurrent += inv.owing;
          } else if (inv.days_late <= 30) {
            entity1 += inv.owing;
          } else if (inv.days_late <= 60) {
            entity30 += inv.owing;
          } else if (inv.days_late <= 90) {
            entity60 += inv.owing;
          } else {
            entity90 += inv.owing;
          }
        }
      }
      reportBalance += entityOwing;
      reportAmount += entityAmount;
      reportApplied += entityApplied;
      reportCurrent += entityCurrent;
      report1 += entity1;
      report30 += entity30;
      report60 += entity60;
      report90 += entity90;
      this.vm.report[x].totalOwing = entityOwing;
      this.vm.report[x].totalAmount = entityAmount;
      this.vm.report[x].totalApplied = entityApplied;
      this.vm.report[x].totalCurrent = entityCurrent;
      this.vm.report[x].total1to30 = entity1;
      this.vm.report[x].total31to60 = entity30;
      this.vm.report[x].total61to90 = entity60;
      this.vm.report[x].total91plus = entity90;
    }
    this.vm.totalOwing = reportBalance;
    this.vm.totalCurrent = reportCurrent;
    this.vm.total1to30 = report1;
    this.vm.total31to60 = report30;
    this.vm.total61to90 = report60;
    this.vm.total91plus = report90;
  }

  encodeQueryData(data) {
    const ret = [];
    for (const d in data) {
      if (data[d] != null && data[d] !== '') {
        ret.push(encodeURIComponent(d) + '=' + encodeURIComponent(data[d]));
      }
    }
    return ret.join('&');
  }

  emailReport(toEmail) {
    // console.log('here');
    // let tempPdfHtml = '';
    // let msgString = '';
    // if (this.vm.report_format) {
    //   tempPdfHtml = this.EmailContent.nativeElement.innerHTML;
    //   msgString =  $localize`:Statement Report @@statementReport:Statement Report`;
    // } else if(!this.vm.report_format ) {
    //   this.FormDocument.forEach((element, index) => {
    //     tempPdfHtml += element.nativeElement.outerHTML;
    //   });
    //   msgString =  $localize`:Statement @@statement:Statement`;
    // }
    //
    // // console.log('report fromat: ' + this.vm.report_format);
    // // console.log('report fromat: ' + tempPdfHtml);
    //
    // this.vm.email.toemail = toEmail;
    // this.vm.email.PdfHtml = tempPdfHtml;
    // this.vm.email.Subject = msgString + ' ' + this.vm.request.toDate;
    // if (tempPdfHtml != '') {
    //   // this.aEmail.sendEmail(this.vm.email);
    // } else {
    //   this.notificationService.showWarningToast('There is no email content to send');
    // }
  }

  selectEntityModal(entityName) {
    this.vm.request.entity_id = '';
    if (this.vm.request.entity_id == '' || 1 === 1) {
      for (const [y, value] of Object.entries(this.vm.entity)) {
        if (this.vm.entity[y].name == entityName) {
          this.vm.entityInput = entityName;
          this.vm.request.entity_id = this.vm.entity[y].id;
          this.vm.entity_email = this.vm.entity[y].email;
          this.vm.report = [];
          break;
        }
      }
    }
  }

  testEntity() {
    const entityIdStart = this.vm.request.entity_id;
    if (!this.vm.entityInput || this.vm.entityInput == '' || this.vm.entityInput == null) {
      this.vm.request.entity_id = '';
    } else {
      if (this.FilterObject(this.vm.entity, { name: this.vm.entityInput }).length > 0) {
        const entityId = this.FilterObject(this.vm.entity, { name: this.vm.entityInput }, true)[0].id;
        const entityName = this.FilterObject(this.vm.entity, { name: this.vm.entityInput }, true)[0].name;
        const entityEmail = this.FilterObject(this.vm.entity, { name: this.vm.entityInput }, true)[0].email;
        if (entityId != '' || entityId != null) {
          this.vm.request.entity_id = entityId;
          this.vm.entityInput = entityName;
          this.vm.entity_email = entityEmail;
        } else {
          this.vm.request.entity_id = '';
          this.vm.entity_email = '';
        }
      } else {
        this.vm.request.entity_id = '';
        this.vm.entity_email = '';
      }
    }
    if (entityIdStart != this.vm.request.entity_id) {
      this.vm.report = [];
    }
  }

  updateEntity() {
    this.vm.buttonsDisabled = true;
    // this.localStorage.StorageSet('entity', '');
    this.tableDataService
        .getData('entity', '?state=active&pageNumber=0&pageSize=99999')
      .subscribe((result: ResponseModel) => {
        this.vm.entity = result.Data;
        this.vm.buttonsDisabled = false;
      });
  }

  FilterObject(value, filterObj, except = false) {
    return new FilterPipe().transform(value, filterObj);
  }

  close() {
    if (this.routedFrom) {
      this.router.navigateByUrl(this.routedFrom).then();
    } else if (this.routedFrom === '' || this.routedFrom == undefined) {
      window.close();
    } else {
      this.router.navigateByUrl('/home').then();
    }
  }

  clear() {
    this.vm.request = {};
    this.vm.report = [];
    this.vm.entityInput = '';
  }
}
